import {Discount, DiscountCategory} from '../UpdateConfirmationModal';

import {MappedDiscounts} from './DiscountSection.types';

/**
 * These discount titles are also referenced in `tally-shop-app/blob/main/web/utils/discounts.util.ts`.
 * Any updates should be synchronized with that file to avoid discrepancies
 * in the display of bundle discounts across the app.
 * @see https://github.com/Tally-Health/tally-shop-app/blob/main/web/utils/discounts.util.ts
 */

// Discounts titles
export enum DiscountTitles {
  MEMBERSHIP_DISCOUNT = 'Membership Discount',
  SUBSCRIPTION_DISCOUNT = 'Subscription Savings',
}

export const mapDiscountsToDiscountRows = (discounts: Discount[]): MappedDiscounts => {
  const membershipDiscount = discounts
    .filter(discount => discount?.category?.toUpperCase() === DiscountCategory.MEMBERSHIP)
    .reduce(
      (acc: {total: number; title: string}, discount: Discount) => {
        acc.total += discount.value;
        return acc;
      },
      {total: 0, title: DiscountTitles.MEMBERSHIP_DISCOUNT},
    );
  const bundleDiscount = discounts
    .filter(discount => discount?.category?.toUpperCase() === DiscountCategory.SUBSCRIPTION)
    .reduce(
      (acc: {total: number; title: string}, discount: Discount) => {
        acc.total += discount.value;
        acc.title = DiscountTitles.SUBSCRIPTION_DISCOUNT;
        return acc;
      },
      {total: 0, title: DiscountTitles.SUBSCRIPTION_DISCOUNT},
    );

  const promoCodeList = discounts
    ?.filter(discount => discount?.category?.toUpperCase() === DiscountCategory.CODE)
    .map(discount => {
      return {
        code: discount.title,
        total: discount.value,
      };
    });
  return {
    membership: membershipDiscount,
    bundle: bundleDiscount,
    promoCodes: promoCodeList,
  };
};
